import { Typography } from '@mui/material'
import CompaniesAutocomplete from 'shared/components/CompaniesAutocomplete/CompaniesAutocomplete'
import { CompaniesAutocompleteProps } from 'shared/components/CompaniesAutocomplete/CompaniesAutocompleteProps'
import { StyledInputLabel } from '../styled'

interface ToggleEditSelectFieldProps extends CompaniesAutocompleteProps<false> {
    edit: boolean
    label: string
    labelId: string
    error?: boolean
    helperText?: string
}

type Props = Omit<ToggleEditSelectFieldProps, 'renderInput'>

const ToggleEditCompaniesAutocomplete = ({
    edit,
    label,
    labelId,
    disabled,
    value,
    error,
    helperText,
    ...rest
}: Props) => {
    let displayValue = Array.isArray(value)
        ? value.map((option) => option.value).join(', ')
        : value?.value

    if (edit)
        return (
            <CompaniesAutocomplete
                {...rest}
                value={value}
                fullWidth
                id={labelId}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.value}
                disabled={disabled}
            />
        )
    return (
        <>
            <StyledInputLabel>{label}</StyledInputLabel>
            <Typography variant="body1">{displayValue || '-'}</Typography>
        </>
    )
}

export default ToggleEditCompaniesAutocomplete
